export default {
    be: {
        tts: {
            home: {
                workshops: "Jouw Breakout sessies",
            },
            menu: {
                workshop: "Breakout",
                workshops: "Breakouts",
            },
            sidebar: {
                "end-workshop": "Beëindig breakout sessie",
            },
        },
    },
    en: {
        passwords: {
            reset: "Your password has been reset!",
            sent: "We have emailed your password reset link!",
            throttled: "Please wait before retrying.",
            token: "This password reset token is invalid.",
            user: "We can't find a user with that email address.",
        },
        auth: {
            failed: "These credentials do not match our records.",
            throttle:
                "Too many login attempts. Please try again in {seconds} seconds.",
        },
        pagination: {
            next: "Next &raquo;",
            previous: "&laquo; Previous",
        },
        tts: {
            babbelbox: {
                full: "There are no more places available to participate in this session with a webcam.<br>Please wait for someone to exit this session, or select another session from the overview.",
                join: "There are  <b>{available}</b> places available from the <b>{limit}</b> to join\nthis session with a webcam.",
                "one-left":
                    "There is  <b>1</b> place available to participate in this session with a webcam!",
            },
            cancel: "Cancel",
            chats: {
                delete: "Delete message",
                "delete-message": "Delete message?",
                "is-closed": "Chat is (temporarily) closed",
                "open-chat": "Open chat",
                "open-chat-text": "Re-open the Chat again?",
                "open-chat-title": "Open chat",
                pin: "Pin message",
                "pin-title": "Pin Message",
                "pinned-chats": "Pinned chats",
                "stop-chat": "Close chat",
                "stop-chat-text":
                    "Are you sure you want to (temporarily) close the chat?",
                "stop-chat-title": "Close chat",
                unpin: "Unpin message",
                "unpin-title": "Unpin message",
                "your-message": "Your chatmessage...",
            },
            close: "Close",
            home: {
                workshops: "Your personal programme",
            },
            login: {
                access_code_text:
                    "you have received a unique access number from the organiser, you can enter it below as an alternative to SMS verification.",
                accesscode: "Accesscode",
                "enter-code":
                    "enter the verification code you received by SMS on your phone with number",
                "get-access": "Get access",
                "get-help": "Need help?  Watch the instructional videos here.",
                "get-sms": "Click here to receive an SMS with an access code",
                "incorrect-accesscode": "Given accesscode is incorrect.",
                "known-number":
                    "the following telephone number is known to us:",
                "new-code": "Request another code here",
                "not-possible": "Two-step verification not possible",
                "onbtained-code": "Obtained access code",
                "sms-code": "SMS acces code",
                "sms-title": "Two-step verification SMS verification",
                "sms-verify": "Verify",
                tweestapsverificatie: "Two-step verification",
                uitloggen: "log out",
                "went-wrong": "Something went wrong",
                "wrong-code": "This is not the code you received by SMS.",
                "wrong-phone":
                    "The registered phone number is incorrect. Please contact the organization to resolve this.",
            },
            menu: {
                break: "Break",
                documents: "Documents",
                logout: "Logout",
                mainstage: "Mainstage",
                reception: "Reception Area",
                talk: "Talk",
                timetable: "Timetable",
                workshop: "Workshop",
                workshops: "Workshops",
            },
            no: "No",
            polls: {
                "answer-confirm":
                    'Are you sure that you want to vote for: ":value"?',
                "answer-submit-error": "Failed",
                "answer-submit-title": "Submit vote",
                "error-403": "You have no permission to vote (anymore)",
                "error-closed": "The Poll is closed. You are too late to vote.",
                init: "Initiate a poll",
                naming: "Polls",
                "new-poll": "New poll",
                "new-poll-info":
                    "Add a poll to your event that your attendees with voting rights can respond to.",
                "new-row": "Every option on a new row",
                options: "Poll options",
                question: "Question",
                stop: "Stop poll",
                "stop-poll-confirm": "Are you sure you want to stop this Poll?",
                "submit-new-poll": "Submit poll",
                "submit-wrong": "Something went wrong",
                vote: "Vote",
                votes: "votes",
                weight: "weight",
                "wrong-empty":
                    "Are you ready you want to submit this Poll to all online Attendees?",
                "wrong-two-options": "A Poll needs at least two options",
            },
            precall: {
                text: "Allow your browser to access your camera and microphone: Some operating systems (for example on an Apple) require a browser to access your camera and microphone. These changes are made to your computer's system settings.\n",
                title: "Test your webcam",
                "webcam-test": "Precall test",
            },
            profile: {
                connect: "Connect",
                edit: "Edit",
                "linkedin-connect":
                    "Do you want to post the profile picture of your LinkedIn profile?",
                picture: "Profile photo",
                profile: "Profile",
                save: "Save",
                visibility:
                    "The information you enter is visible to other participants in this event.",
            },
            sidebar: {
                attendees: "Attendees",
                chat: "Chat",
                "clear-chat-text":
                    "Are you sure you want the cleanup the chat history?",
                "clear-chat-title": "Clear Chat history",
                "clear-chats": "Clear chathistory",
                "end-workshop": "End workshop",
                info: "Documents",
                "marked-chats": "Marked chats",
                polls: "Polls",
                "show-chat": "Show normal chat",
                "show-pinned": "Show pinned chat",
            },
            workshops: {
                "redirect-helper":
                    "Choose a room where you want to send the attendees.",
                "redirect-title": "End workshop",
                "starting-on": "Starting on",
            },
            yes: "Yes",
        },
        "validation-inline": {
            accepted: "",
            active_url: "",
            after: "",
            after_or_equal: "",
            alpha: "",
            alpha_dash: "",
            alpha_num: "",
            array: "",
            before: "",
            before_or_equal: "",
            between: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            boolean: "",
            confirmed: "",
            custom: {
                "attribute-name": {
                    "rule-name": "",
                },
            },
            date: "",
            date_equals: "",
            date_format: "",
            different: "",
            digits: "",
            digits_between: "",
            dimensions: "",
            distinct: "",
            email: "",
            ends_with: "",
            exists: "",
            file: "",
            filled: "",
            gt: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            gte: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            image: "",
            in: "",
            in_array: "",
            integer: "",
            ip: "",
            ipv4: "",
            ipv6: "",
            json: "",
            lt: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            lte: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            max: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            mimes: "",
            mimetypes: "",
            min: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            not_in: "",
            not_regex: "",
            numeric: "",
            password: "",
            present: "",
            regex: "",
            required: "",
            required_if: "",
            required_unless: "",
            required_with: "",
            required_with_all: "",
            required_without: "",
            required_without_all: "",
            same: "",
            size: {
                array: "",
                file: "",
                numeric: "",
                string: "",
            },
            starts_with: "",
            string: "",
            timezone: "",
            unique: "",
            uploaded: "",
            url: "",
            uuid: "",
        },
        validation: {
            accepted: "The {attribute} must be accepted.",
            active_url: "The {attribute} is not a valid URL.",
            after: "The {attribute} must be a date after {date}.",
            after_or_equal:
                "The {attribute} must be a date after or equal to {date}.",
            alpha: "The {attribute} may only contain letters.",
            alpha_dash:
                "The {attribute} may only contain letters, numbers, dashes and underscores.",
            alpha_num: "The {attribute} may only contain letters and numbers.",
            array: "The {attribute} must be an array.",
            attributes: {
                address: "",
                age: "",
                amount: "",
                available: "",
                bg_color: "",
                button_color: "",
                city: "",
                content: "",
                country: "",
                currency: "",
                date: "",
                date_of_birth: "",
                day: "",
                description: "",
                duration: "",
                email: "",
                excerpt: "",
                first_name: "",
                gender: "",
                group: "",
                hour: "",
                last_name: "",
                lesson: "",
                message: "",
                minute: "",
                mobile: "",
                month: "",
                name: "",
                password: "",
                password_confirmation: "",
                phone: "",
                price: "",
                second: "",
                sex: "",
                size: "",
                street: "",
                student: "",
                subject: "",
                teacher: "",
                telephone: "",
                text_color: "",
                time: "",
                title: "",
                username: "",
                year: "",
            },
            before: "The {attribute} must be a date before {date}.",
            before_or_equal:
                "The {attribute} must be a date before or equal to {date}.",
            between: {
                array: "The {attribute} must have between {min} and {max} items.",
                file: "The {attribute} must be between {min} and {max} kilobytes.",
                numeric: "The {attribute} must be between {min} and {max}.",
                string: "The {attribute} must be between {min} and {max} characters.",
            },
            boolean: "The {attribute} field must be true or false.",
            confirmed: "The {attribute} confirmation does not match.",
            custom: {
                "attribute-name": {
                    "rule-name": "custom-message",
                },
            },
            date: "The {attribute} is not a valid date.",
            date_equals: "The {attribute} must be a date equal to {date}.",
            date_format: "The {attribute} does not match the format {format}.",
            different: "The {attribute} and {other} must be different.",
            digits: "The {attribute} must be {digits} digits.",
            digits_between:
                "The {attribute} must be between {min} and {max} digits.",
            dimensions: "The {attribute} has invalid image dimensions.",
            distinct: "The {attribute} field has a duplicate value.",
            email: "The {attribute} must be a valid email address.",
            ends_with:
                "The {attribute} must end with one of the following: {values}.",
            exists: "The selected {attribute} is invalid.",
            file: "The {attribute} must be a file.",
            filled: "The {attribute} field must have a value.",
            gt: {
                array: "The {attribute} must have more than {value} items.",
                file: "The {attribute} must be greater than {value} kilobytes.",
                numeric: "The {attribute} must be greater than {value}.",
                string: "The {attribute} must be greater than {value} characters.",
            },
            gte: {
                array: "The {attribute} must have {value} items or more.",
                file: "The {attribute} must be greater than or equal {value} kilobytes.",
                numeric:
                    "The {attribute} must be greater than or equal {value}.",
                string: "The {attribute} must be greater than or equal {value} characters.",
            },
            image: "The {attribute} must be an image.",
            in: "The selected {attribute} is invalid.",
            in_array: "The {attribute} field does not exist in {other}.",
            integer: "The {attribute} must be an integer.",
            ip: "The {attribute} must be a valid IP address.",
            ipv4: "The {attribute} must be a valid IPv4 address.",
            ipv6: "The {attribute} must be a valid IPv6 address.",
            json: "The {attribute} must be a valid JSON string.",
            lt: {
                array: "The {attribute} must have less than {value} items.",
                file: "The {attribute} must be less than {value} kilobytes.",
                numeric: "The {attribute} must be less than {value}.",
                string: "The {attribute} must be less than {value} characters.",
            },
            lte: {
                array: "The {attribute} must not have more than {value} items.",
                file: "The {attribute} must be less than or equal {value} kilobytes.",
                numeric: "The {attribute} must be less than or equal {value}.",
                string: "The {attribute} must be less than or equal {value} characters.",
            },
            max: {
                array: "The {attribute} may not have more than {max} items.",
                file: "The {attribute} may not be greater than {max} kilobytes.",
                numeric: "The {attribute} may not be greater than {max}.",
                string: "The {attribute} may not be greater than {max} characters.",
            },
            mimes: "The {attribute} must be a file of type: {values}.",
            mimetypes: "The {attribute} must be a file of type: {values}.",
            min: {
                array: "The {attribute} must have at least {min} items.",
                file: "The {attribute} must be at least {min} kilobytes.",
                numeric: "The {attribute} must be at least {min}.",
                string: "The {attribute} must be at least {min} characters.",
            },
            not_in: "The selected {attribute} is invalid.",
            not_regex: "The {attribute} format is invalid.",
            numeric: "The {attribute} must be a number.",
            password: "The password is incorrect.",
            phone: "The {attribute} field contains an invalid number.",
            present: "The {attribute} field must be present.",
            pwned: "",
            regex: "The {attribute} format is invalid.",
            required: "The {attribute} field is required.",
            required_if:
                "The {attribute} field is required when {other} is {value}.",
            required_unless:
                "The {attribute} field is required unless {other} is in {values}.",
            required_with:
                "The {attribute} field is required when {values} is present.",
            required_with_all:
                "The {attribute} field is required when {values} are present.",
            required_without:
                "The {attribute} field is required when {values} is not present.",
            required_without_all:
                "The {attribute} field is required when none of {values} are present.",
            same: "The {attribute} and {other} must match.",
            size: {
                array: "The {attribute} must contain {size} items.",
                file: "The {attribute} must be {size} kilobytes.",
                numeric: "The {attribute} must be {size}.",
                string: "The {attribute} must be {size} characters.",
            },
            starts_with:
                "The {attribute} must start with one of the following: {values}.",
            string: "The {attribute} must be a string.",
            timezone: "The {attribute} must be a valid zone.",
            unique: "The {attribute} has already been taken.",
            uploaded: "The {attribute} failed to upload.",
            url: "The {attribute} format is invalid.",
            uuid: "The {attribute} must be a valid UUID.",
        },
    },
    nl: {
        passwords: {
            reset: "Het wachtwoord van uw account is gewijzigd.",
            sent: "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            throttled: "Gelieve even te wachten voor u het opnieuw probeert.",
            token: "Dit wachtwoordhersteltoken is niet geldig.",
            user: "Geen gebruiker bekend met het e-mailadres.",
        },
        auth: {
            failed: "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            throttle:
                "Te veel mislukte loginpogingen. Probeer het over {seconds} seconden nogmaals.",
        },
        pagination: {
            next: "Volgende &raquo;",
            previous: "&laquo; Vorige",
        },
        tts: {
            babbelbox: {
                full: "Er zijn geen plaatsen meer beschikbaar om zelf deel te nemen aan deze sessie met een webcam.<br>Wacht tot iemand deze sessie verlaat of selecteer een andere sessie in het overzicht.",
                join: "Er zijn nog <b>{available}</b> plaatsen beschikbaar van de <b>{limit}</b> om deel te nemen aan deze sessie met een webcam.",
                "one-left":
                    "Er is nog <b>1</b> plaats beschikbaar om zelf deel te nemen aan deze sessie met een webcam!",
            },
            cancel: "Annuleer",
            chats: {
                delete: "Wis bericht",
                "delete-message": "Bericht wissen?",
                "is-closed": "Chat is tijdelijk gesloten",
                "open-chat": "Open chat",
                "open-chat-text": "Wil je de Chat weer openen?",
                "open-chat-title": "Open chat",
                pin: "Markeer bericht",
                "pin-title": "Markeer bericht",
                "pinned-chats": "Gemarkeerde berichten",
                "stop-chat": "Sluit chat",
                "stop-chat-text":
                    "Weet je zeker dat je de chat (tijdelijk) wilt sluiten?",
                "stop-chat-title": "Chat sluiten",
                unpin: "Wis markering",
                "unpin-title": "Markering weghalen",
                "your-message": "Jouw bericht...",
            },
            close: "Sluiten",
            home: {
                workshops: "Jouw persoonlijke programma",
            },
            login: {
                access_code_text:
                    "u hebt een uniek toegangsnummer gekregen van de organisator, u kunt dat hieronder invullen als alternatief voor de SMS validatie.",
                accesscode: "Toegangscode",
                "enter-code":
                    "voer de verificatiecode in die u per SMS hebt ontvangen op uw telefoon met nummer",
                "get-access": "Login",
                "get-help": "Hulp nodig? Bekijk hier de instructie-video's.",
                "get-sms":
                    "Klik hier om een SMS te ontvangen met een toegangscode",
                "incorrect-accesscode": "Opgegeven code is incorrect",
                "known-number":
                    "bij ons is het volgende telefoonnummer bekend:",
                "new-code": "Vraag hier opnieuw een code aan",
                "not-possible": "Tweestapsverificatie niet mogelijk",
                "onbtained-code": "Verkregen toegangscode",
                "sms-code": "Code uit de SMS",
                "sms-title": "Tweestapsverificatie SMS-controle",
                "sms-verify": "Verifiëren",
                tweestapsverificatie: "Tweestapsverificatie",
                uitloggen: "uitloggen",
                "went-wrong": "Daar ging wat mis",
                "wrong-code":
                    "Dit is niet de code die u per SMS hebt ontvangen.",
                "wrong-phone":
                    "Het telefoonnummer dat van u bekend is, is onjuist. Neem contact op met de organisator om dit te verhelpen.",
            },
            menu: {
                break: "Pauze",
                documents: "Documenten",
                logout: "Uitloggen",
                mainstage: "Mainstage",
                reception: "Receptie",
                talk: "Talk",
                timetable: "Programma",
                workshop: "Workshop",
                workshops: "Workshops",
            },
            no: "Nee",
            polls: {
                "answer-confirm":
                    'Weet je zeker dat je wil stemmen op: ":value"?',
                "answer-submit-error": "Mislukt",
                "answer-submit-title": "Verstuur stem",
                "error-403": "Je hebt geen toestemming (meer) om te stemmen",
                "error-closed":
                    "De stemming is gesloten. U bent te laat om te stemmen.",
                init: "Initieer een stemming",
                naming: "Stemmingen",
                "new-poll": "Nieuwe stemming",
                "new-poll-info":
                    "Voeg een stemming toe waar de deelnemers met stemrecht op kunnen reageren.",
                "new-row": "Elke optie op een nieuwe rij",
                options: "Keuze-opties",
                question: "Vraagstelling",
                stop: "Stop stemming",
                "stop-poll-confirm": "Wilt u de stemming sluiten?",
                "submit-new-poll": "Verstuur stemming",
                "submit-wrong": "Er is iets fout gegaan",
                vote: "Stem",
                votes: "stemmen",
                weight: "gewicht",
                "wrong-empty":
                    "Ben je er klaar voor om deze stemming in te dienen voor alle online deelnemers?",
                "wrong-two-options":
                    "Een stemming moet minimaal twee opties hebben",
            },
            precall: {
                text: "Geef uw browser toestemming om toegang te krijgen tot camera en microfoon: voor sommige besturingssystemen (bijvoorbeeld op een een Apple) moet u een browser toegang verlenen tot uw camera en microfoon. Deze wijzigingen worden aangebracht in de systeeminstellingen van uw computer.",
                title: "Test hier uw webcam",
                "webcam-test": "Webcam-test",
            },
            profile: {
                connect: "Koppelen",
                edit: "Bewerken",
                "linkedin-connect":
                    "Wil je je profielfoto van je LinkedIn-profiel halen?",
                picture: "Profielfoto",
                profile: "Profiel",
                save: "Opslaan",
                visibility:
                    "De gegevens die je invult zijn zichtbaar voor andere deelnemers aan dit evenement.",
            },
            sidebar: {
                attendees: "Deelnemers",
                chat: "Chat",
                "clear-chat-text":
                    "Weet u zeker dat u de chathistorie wilt opschonen?",
                "clear-chat-title": "Leeg chathistorie",
                "clear-chats": "Leeg chathistorie",
                "end-workshop": "Beëindig workshop",
                info: "Documenten",
                "marked-chats": "Gemarkeerde chats",
                polls: "Stemmingen",
                "show-chat": "Toon reguliere chat",
                "show-pinned": "Toon gemarkeerde chats",
            },
            workshops: {
                "redirect-helper":
                    "Kies een ruimte waar je de gebruikers naar toe wil sturen.",
                "redirect-title": "Beëindig workshop",
                "starting-on": "Start om",
            },
            yes: "Ja",
        },
        "validation-inline": {
            accepted: "Dit veld moet geaccepteerd zijn.",
            active_url: "Dit is geen geldige URL.",
            after: "Dit moet een datum na {date} zijn.",
            after_or_equal: "Dit moet een datum na of gelijk aan {date} zijn.",
            alpha: "Dit veld mag alleen letters bevatten.",
            alpha_dash:
                "Dit veld mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            alpha_num: "Dit veld mag alleen letters en nummers bevatten.",
            array: "Dit veld moet geselecteerde elementen bevatten.",
            before: "Dit moet een datum voor {date} zijn.",
            before_or_equal:
                "Dit moet een datum voor of gelijk aan {date} zijn.",
            between: {
                array: "Dit moet tussen {min} en {max} items bevatten.",
                file: "Dit moet tussen {min} en {max} kilobytes zijn.",
                numeric: "Dit moet tussen {min} en {max} zijn.",
                string: "Dit moet tussen {min} en {max} karakters zijn.",
            },
            boolean: "Dit veld moet ja of nee zijn.",
            confirmed: "De bevestiging komt niet overeen.",
            custom: {
                "attribute-name": {
                    "rule-name": "custom-message",
                },
            },
            date: "Dit is geen geldige datum",
            date_equals: "Dit moet een datum gelijk aan {date} zijn.",
            date_format: "Dit voldoet niet aan het formaat {format}.",
            different: "Dit en {other} moeten verschillend zijn.",
            digits: "Dit moet bestaan uit {digits} cijfers.",
            digits_between:
                "Dit moet bestaan uit minimaal {min} en maximaal {max} cijfers.",
            dimensions: "Deze afbeelding heeft geen geldige afmetingen.",
            distinct: "Dit veld heeft een dubbele waarde.",
            email: "Dit is geen geldig e-mailadres.",
            ends_with:
                "Dit moet met één van de volgende waarden eindigen: {values}.",
            exists: "De geselecteerde waarde bestaat niet.",
            file: "Dit moet een bestand zijn.",
            filled: "Dit veld is verplicht.",
            gt: {
                array: "De inhoud moet meer dan {value} waardes bevatten.",
                file: "Het bestand moet groter zijn dan {value} kilobytes.",
                numeric: "De waarde moet groter zijn dan {value}.",
                string: "De waarde moet meer dan {value} tekens bevatten.",
            },
            gte: {
                array: "De inhoud moet {value} waardes of meer bevatten.",
                file: "Het bestand moet groter of gelijk zijn aan {value} kilobytes.",
                numeric: "De waarde moet groter of gelijk zijn aan {value}.",
                string: "De waarde moet minimaal {value} tekens bevatten.",
            },
            image: "Dit moet een afbeelding zijn.",
            in: "De geselecteerde waarde is ongeldig.",
            in_array: "Deze waarde bestaat niet in {other}.",
            integer: "Dit moet een getal zijn.",
            ip: "Dit moet een geldig IP-adres zijn.",
            ipv4: "Dit moet een geldig IPv4-adres zijn.",
            ipv6: "Dit moet een geldig IPv6-adres zijn.",
            json: "Dit moet een geldige JSON-string zijn.",
            lt: {
                array: "De inhoud moet minder dan {value} waardes bevatten.",
                file: "Het bestand moet kleiner zijn dan {value} kilobytes.",
                numeric: "De waarde moet kleiner zijn dan {value}.",
                string: "De waarde moet minder dan {value} tekens bevatten.",
            },
            lte: {
                array: "De inhoud moet {value} waardes of minder bevatten.",
                file: "Het bestand moet kleiner of gelijk zijn aan {value} kilobytes.",
                numeric: "De waarde moet kleiner of gelijk zijn aan {value}.",
                string: "De waarde moet maximaal {value} tekens bevatten.",
            },
            max: {
                array: "De inhoud mag niet meer dan {max} items bevatten.",
                file: "Het bestand mag niet meer dan {max} kilobytes zijn.",
                numeric: "De waarde mag niet hoger dan {max} zijn.",
                string: "De waarde mag niet uit meer dan {max} tekens bestaan.",
            },
            mimes: "Dit moet een bestand zijn van het bestandstype {values}.",
            mimetypes:
                "Dit moet een bestand zijn van het bestandstype {values}.",
            min: {
                array: "De inhoud moet minimaal {min} items bevatten.",
                file: "Het bestand moet minimaal {min} kilobytes zijn.",
                numeric: "De waarde moet minimaal {min} zijn.",
                string: "De waarde moet minimaal {min} tekens zijn.",
            },
            not_in: "De geselecteerde waarde is ongeldig.",
            not_regex: "Dit formaat is ongeldig.",
            numeric: "Dit moet een nummer zijn",
            password: "Het wachtwoord is onjuist.",
            present: "Dit veld moet bestaan.",
            regex: "Dit formaat is ongeldig.",
            required: "Dit veld is verplicht.",
            required_if:
                "Dit veld is verplicht indien {other} gelijk is aan {value}.",
            required_unless:
                "Dit veld is verplicht tenzij {other} gelijk is aan {values}.",
            required_with: "Dit veld is verplicht i.c.m. {values}",
            required_with_all: "Dit veld is verplicht i.c.m. {values}",
            required_without:
                "Dit veld is verplicht als {values} niet ingevuld is.",
            required_without_all:
                "Dit veld is verplicht als {values} niet ingevuld zijn.",
            same: "De waarde van dit veld en {other} moeten overeenkomen.",
            size: {
                array: "{de} inhoud moet {size} items bevatten.",
                file: "{Het} bestand moet {size} kilobyte zijn.",
                numeric: "{De} waarde moet {size} zijn.",
                string: "{De} waarde moet {size} tekens zijn.",
            },
            starts_with: "Dit moet starten met een van de volgende: {values}.",
            string: "Dit moet een tekst zijn.",
            timezone: "Dit moet een geldige tijdzone zijn.",
            unique: "Deze is al in gebruik",
            uploaded: "Het uploaden hiervan is mislukt.",
            url: "Dit moet een geldige URL zijn.",
            uuid: "Dit moet een geldige UUID zijn.",
        },
        validation: {
            accepted: "{Attribute} moet geaccepteerd zijn.",
            active_url: "{Attribute} is geen geldige URL.",
            after: "{Attribute} moet een datum na {date} zijn.",
            after_or_equal:
                "{Attribute} moet een datum na of gelijk aan {date} zijn.",
            alpha: "{Attribute} mag alleen letters bevatten.",
            alpha_dash:
                "{Attribute} mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            alpha_num: "{Attribute} mag alleen letters en nummers bevatten.",
            array: "{Attribute} moet geselecteerde elementen bevatten.",
            attributes: {
                address: "adres",
                age: "leeftijd",
                amount: "bedrag",
                available: "beschikbaar",
                bg_color: "achtergrondkleur",
                button_color: "buttonkleur",
                city: "stad",
                content: "inhoud",
                country: "land",
                currency: "valuta",
                date: "datum",
                date_of_birth: "geboortedatum",
                day: "dag",
                description: "omschrijving",
                duration: "tijdsduur",
                email: "e-mailadres",
                excerpt: "uittreksel",
                first_name: "voornaam",
                gender: "geslacht",
                group: "groep",
                hour: "uur",
                last_name: "achternaam",
                lesson: "les",
                message: "bericht",
                minute: "minuut",
                mobile: "mobiel",
                month: "maand",
                name: "naam",
                password: "wachtwoord",
                password_confirmation: "wachtwoordbevestiging",
                phone: "telefoonnummer",
                price: "prijs",
                second: "seconde",
                sex: "geslacht",
                size: "grootte",
                street: "straatnaam",
                student: "student",
                subject: "onderwerp",
                teacher: "Docent",
                telephone: "telefoonnummer",
                text_color: "tekstkleur",
                time: "tijd",
                title: "titel",
                username: "gebruikersnaam",
                year: "jaar",
            },
            before: "{Attribute} moet een datum voor {date} zijn.",
            before_or_equal:
                "{Attribute} moet een datum voor of gelijk aan {date} zijn.",
            between: {
                array: "{Attribute} moet tussen {min} en {max} items bevatten.",
                file: "{Attribute} moet tussen {min} en {max} kilobytes zijn.",
                numeric: "{Attribute} moet tussen {min} en {max} zijn.",
                string: "{Attribute} moet tussen {min} en {max} karakters zijn.",
            },
            boolean: "{Attribute} moet ja of nee zijn.",
            confirmed: "{Attribute} bevestiging komt niet overeen.",
            custom: {
                "attribute-name": {
                    "rule-name": "custom-message",
                },
            },
            date: "{Attribute} moet een datum bevatten.",
            date_equals: "{Attribute} moet een datum gelijk aan {date} zijn.",
            date_format: "{Attribute} moet een geldig datum formaat bevatten.",
            different: "{Attribute} en {other} moeten verschillend zijn.",
            digits: "{Attribute} moet bestaan uit {digits} cijfers.",
            digits_between:
                "{Attribute} moet bestaan uit minimaal {min} en maximaal {max} cijfers.",
            dimensions:
                "{Attribute} heeft geen geldige afmetingen voor afbeeldingen.",
            distinct: "{Attribute} heeft een dubbele waarde.",
            email: "{Attribute} is geen geldig e-mailadres.",
            ends_with:
                "{Attribute} moet met één van de volgende waarden eindigen: {values}.",
            exists: "{Attribute} bestaat niet.",
            file: "{Attribute} moet een bestand zijn.",
            filled: "{Attribute} is verplicht.",
            gt: {
                array: "De {attribute} moet meer dan {value} waardes bevatten.",
                file: "De {attribute} moet groter zijn dan {value} kilobytes.",
                numeric: "De {attribute} moet groter zijn dan {value}.",
                string: "De {attribute} moet meer dan {value} tekens bevatten.",
            },
            gte: {
                array: "De {attribute} moet {value} waardes of meer bevatten.",
                file: "De {attribute} moet groter of gelijk zijn aan {value} kilobytes.",
                numeric:
                    "De {attribute} moet groter of gelijk zijn aan {value}.",
                string: "De {attribute} moet minimaal {value} tekens bevatten.",
            },
            image: "{Attribute} moet een afbeelding zijn.",
            in: "{Attribute} is ongeldig.",
            in_array: "{Attribute} bestaat niet in {other}.",
            integer: "{Attribute} moet een getal zijn.",
            ip: "{Attribute} moet een geldig IP-adres zijn.",
            ipv4: "{Attribute} moet een geldig IPv4-adres zijn.",
            ipv6: "{Attribute} moet een geldig IPv6-adres zijn.",
            json: "{Attribute} moet een geldige JSON-string zijn.",
            lt: {
                array: "De {attribute} moet minder dan {value} waardes bevatten.",
                file: "De {attribute} moet kleiner zijn dan {value} kilobytes.",
                numeric: "De {attribute} moet kleiner zijn dan {value}.",
                string: "De {attribute} moet minder dan {value} tekens bevatten.",
            },
            lte: {
                array: "De {attribute} moet {value} waardes of minder bevatten.",
                file: "De {attribute} moet kleiner of gelijk zijn aan {value} kilobytes.",
                numeric:
                    "De {attribute} moet kleiner of gelijk zijn aan {value}.",
                string: "De {attribute} moet maximaal {value} tekens bevatten.",
            },
            max: {
                array: "{Attribute} mag niet meer dan {max} items bevatten.",
                file: "{Attribute} mag niet meer dan {max} kilobytes zijn.",
                numeric: "{Attribute} mag niet hoger dan {max} zijn.",
                string: "{Attribute} mag niet uit meer dan {max} tekens bestaan.",
            },
            mimes: "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            mimetypes:
                "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            min: {
                array: "{Attribute} moet minimaal {min} items bevatten.",
                file: "{Attribute} moet minimaal {min} kilobytes zijn.",
                numeric: "{Attribute} moet minimaal {min} zijn.",
                string: "{Attribute} moet minimaal {min} tekens zijn.",
            },
            not_in: "Het formaat van {attribute} is ongeldig.",
            not_regex: "De {attribute} formaat is ongeldig.",
            numeric: "{Attribute} moet een nummer zijn.",
            password: "Wachtwoord is onjuist.",
            phone: "{Attribute} moet een valide nummer zijn.",
            present: "{Attribute} moet bestaan.",
            pwned: "Wachtwoord is onveilig, want bekend in de haveibeenpwned-database",
            regex: "{Attribute} formaat is ongeldig.",
            required: "{Attribute} is verplicht.",
            required_if:
                "{Attribute} is verplicht indien {other} gelijk is aan {value}.",
            required_unless:
                "{Attribute} is verplicht tenzij {other} gelijk is aan {values}.",
            required_with: "{Attribute} is verplicht i.c.m. {values}",
            required_with_all: "{Attribute} is verplicht i.c.m. {values}",
            required_without:
                "{Attribute} is verplicht als {values} niet ingevuld is.",
            required_without_all:
                "{Attribute} is verplicht als {values} niet ingevuld zijn.",
            same: "{Attribute} en {other} moeten overeenkomen.",
            size: {
                array: "{Attribute} moet {size} items bevatten.",
                file: "{Attribute} moet {size} kilobyte zijn.",
                numeric: "{Attribute} moet {size} zijn.",
                string: "{Attribute} moet {size} tekens zijn.",
            },
            starts_with:
                "{Attribute} moet starten met een van de volgende: {values}.",
            string: "{Attribute} moet een tekst zijn.",
            timezone: "{Attribute} moet een geldige tijdzone zijn.",
            unique: "{Attribute} is al in gebruik.",
            uploaded: "Het uploaden van {attribute} is mislukt.",
            url: "{Attribute} moet een geldig URL zijn.",
            uuid: "{Attribute} moet een geldig UUID zijn.",
        },
    },
};
